import { getNodeLink } from '@livv/utils/helpers';
import { Box, Card, List, ListItem, Typography } from '@mui/material';
import { useRouter } from 'next/router';
import useTranslation from 'next-translate/useTranslation';
import { FC } from 'react';
import { PlainLink } from '@components/Links';
import { useBookPageContext } from '@utils/context/book';
import { useBookPathSlugs } from '@utils/hooks/useBookSlugs';

const ChildNodes: FC = () => {
    const { bookData, isLegitext } = useBookPageContext();
    const { bookId, bookPath } = useBookPathSlugs();
    const router = useRouter();
    const { t } = useTranslation('books');

    const { children: childNodes, isPublished: nodePublished } = bookData.getNode(
        bookPath.split('/'),
    );

    // only check publication status for our books, legitexts are published even if attribute is not present in node
    if (!isLegitext && !nodePublished) {
        router.push('/404');
    }

    return (
        <Card
            elevation={0}
            sx={{
                backgroundColor: 'background.paper',
                border: 'none',
                mt: 5,
                px: 2,
                py: 3,
            }}
        >
            {childNodes?.length ? (
                <Box>
                    <Typography data-test-id="child-nodes-title" variant="h2">
                        {t('subparts')}
                    </Typography>
                    <List sx={{ my: 2, pl: 5 }} disablePadding>
                        {childNodes.map(({ id, title }) => (
                            <ListItem key={id} sx={{ listStyleType: 'disc' }} disablePadding>
                                <PlainLink
                                    href={getNodeLink({
                                        bookId,
                                        bookPath: `${bookPath}/${id}`,
                                    })}
                                    sx={{
                                        color: 'text.secondary',
                                        display: 'list-item',
                                        ml: 2,
                                        my: 1,
                                    }}
                                    underline="hover"
                                >
                                    {title}
                                </PlainLink>
                            </ListItem>
                        ))}
                    </List>
                </Box>
            ) : (
                <Typography variant="h3">{t('noSheet')}</Typography>
            )}
        </Card>
    );
};

export default ChildNodes;
